import { makeStyles } from '@mui/styles';
import { COLORS } from '@styles/colors';

export const useStyles = makeStyles({
  tableHeader: {
    '& .MuiTableCell-head': {
      backgroundColor: COLORS.HIGHLIGHTS.NEUTRAL,
      fontSize: 14,
      fontWeight: 500,
      lineHeight: '24px',
      color: COLORS.TEXT.PRIMARY,
    },
  },
  tableBody: {
    '& tr:last-child .MuiTableCell-root': {
      borderBottomColor: 'rgb(0 0 0 / 8%) !important',
      borderBottom: '1px solid rgba(224, 224, 224, 1) !important',
    },
    '& tr': {
      height: '48px !important',
    },
    '& td': {
      padding: '12px 16px !important',
    },

    '& tr.noCustomStyles': {
      height: 'auto !important',
    },
    '& tr.noCustomStyles td': {
      padding: 'initial !important',
    },

    '& td:nth-child(1)': {
      width: '7% !important',
      padding: '12px 0 12px 16px !important',
    },
    '& td:nth-child(2)': {
      width: '7% !important',
      padding: '12px 0 !important',
    },
    '& td:nth-child(3)': {
      width: '70% !important',
    },
    '& td:nth-child(4)': {
      width: '10% !important',
    },
    '& td:nth-child(5)': {
      width: '10% !important',
    },
  },
});
